import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import Link from '@ux/link';
import noop from 'lodash.noop';
import { Menu, MenuButton } from '@ux/menu';
import NavBarItemChildren from './NavBarItemChildren';
import ChevronDown from '@ux/icon/chevron-down';
import createIcon from '@ux/icon/base.js';
import additionalIcons from '../icons';

import Tag from '@ux/tag';

const icons = {
  ...additionalIcons
};

const NavBarItem = forwardRef((props, forwardedRef) => {
  const {
    icon = '',
    active = false,
    className = '',
    id = '',
    href = '#',
    target = null,
    dataAttrs = {},
    caption = null,
    title = null,
    eid = '',
    children = null,
    onClick = noop,
    badge = null
  } = props;

  const _className = classNames(
    'in-page-nav-item',
    { active },
    className
  );

  let iconJsx;

  if (icon) {
    // Use the icon name directly first
    const iconStyle = icon;

    if (!icons[iconStyle]) {
      icons[iconStyle] = createIcon(iconStyle, false);
    }

    const Icon = icons[iconStyle];
    iconJsx = Icon ? <Icon alttext={ caption || title } className='in-page-nav-item-icon' /> : null;
  }

  let badgeJsx = null;
  if (badge?.text) {
    badgeJsx = (
      <Tag type='highlight' size='sm'>
        { badge.text }
      </Tag>
    );
  }

  if (children && children.length) {
    return (
      <Menu ref={ forwardedRef } as='li' id='horizontal-nav' className={ _className }>
        <MenuButton icon={ <ChevronDown /> }>
          { iconJsx }
          { caption || title }
          { badgeJsx }
        </MenuButton>
        <NavBarItemChildren items={ children } />
      </Menu>
    );
  }
  return (
    <li ref={ forwardedRef } className={ _className }>
      <Link
        className='in-page-nav-link'
        id={ id }
        href={ href || '#' }
        target={ target }
        onClicked={ onClick }
        data-eid={ eid }
        { ...dataAttrs }
      >
        { iconJsx }
        { caption || title }
        { badgeJsx }
      </Link>
    </li>
  );

});

NavBarItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  dataAttrs: PropTypes.shape({}),
  caption: PropTypes.node,
  title: PropTypes.node,
  eid: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.shape(NavBarItem.propTypes)),
  badge: PropTypes.shape({
    text: PropTypes.string
  })
};

const NavBarItemPropTypes = NavBarItem.propTypes;
export { NavBarItem as default, NavBarItemPropTypes };
